import { BaseTitolo } from '@lucan/base-ui'

export default function Titoletto(props) {
  const { children, ...rest } = props
  
  return <BaseTitolo variant="h3" {...rest}>{children}</BaseTitolo>
}
